export const filterGroupsList: string[] = ['paid', 'pending', 'canceled'];
